import React from 'react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  return <section className="pt-4 pb-5" data-id="element-194">
      <div className="max-w-3xl mx-auto px-3" data-id="element-195">
        <FadeIn delay={0.4} data-id="element-196">
          <p className="text-center text-lg md:text-xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-[#C9A96E]" data-id="element-197">
            ¿Cuántas veces más vas a salir de consulta sintiendo que podrías
            haber dado más?
          </p>
        </FadeIn>
      </div>
    </section>;
}